import { createPromotedPriceApiClient } from './promotedPriceApiClient'

export const promotedPriceAPIClient = createPromotedPriceApiClient({})
